import { Result } from "../models/interfaces";
import { BaseService } from "./BaseService";

const accountTypeApiBase = "api/accounttype";

export type AccountType = {
  id?: number;
  name?: string;
  transactionLimitTypeId?: number;
  enableSMSAlert?: boolean;
  enableEmailAlert?: boolean;
  smsIncomeAccountId?: number;
  smsExpenseAccountId?: number;
  smsCharge?: number;
  interestRate?: number;
  smsFixedCharge?: number;
  interestIncomeAccountId?: number;
  interestExpenseAccountId?: number;
  accountGroupId?: number;
  accountGroupName?: string;
  minimumBalance?: number;
  smsSenderId?: string;
  enableLoanRepaymentReminder?: boolean;
  interestInSuspenseAccountId?: number;
  interestMaxWithdrawalCount?: number;
  interestMinWithdrawalCount?: number;
  sendAccountOpeningMessage?: boolean;
  allowDebitBalance?: boolean;
  maxNumberOfSignatories?: number;
}

export interface AccountTypeSummary extends AccountType {
  accountGroupName?: string;
  smsIncomeAccountName?: string;
  smsExpenseAccountName?: string;
  interestIncomeAccountName?: string;
  interestExpenseAccountName?: string;
  interestInSuspenseAccountName?: string;
}

class AccountTypeService extends BaseService {
  //Account Type services
  async getAccountTypes(params: {
    id?: number;
    name?: string;
    pageNo?: number;
    pageSize?: number;
  }): Promise<Result<AccountType[]> | undefined> {
    return this.get(`api/accounttype${this.ToQueryString(params)}`);
  }

  async getAcountType(id: number): Promise<Result<AccountType>> {
    return this.get(`api/accounttype/${id}`);
  }

  async deleteAccountType(id: number): Promise<Result<boolean>> {
    return this.delete(`api/accounttypes/${id}`);
  }

  async disableOrEnableAccountType(
    id: number,
    value: boolean
  ): Promise<Result<boolean>> {
    const action = value ? "enable" : "disable";
    return this.patch(`api/accounttype/${id}/${action}`);
  }

  async createOrUpdateAccountType(
    accountType: AccountType
  ): Promise<Result<AccountType | boolean>> {
    return this.post(`api/accounttype`, accountType);
  }

  async setTransactionTypes(
    id: number,
    accountTypes: string[],
    type: string
  ): Promise<Result<boolean>> {
    return this.post(
      `${accountTypeApiBase}/${id}/transactionTypes/${type}`,
      accountTypes
    );
  }

  async getTransactionTypes(id: number): Promise<Result<AccountType[]>> {
    return this.get(`${accountTypeApiBase}/${id}`);
  }
}

export default new AccountTypeService();
